import React, { useState } from "react";
import CustomFilters from "../../../../core/custom-filters";
import { Box } from "@mui/material";
import SiTextField from "../../../../core/si-textfield";
import SiDatePicker from "../../../../core/si-datepicker";
import { PAGE_LIMIT } from "../../../../utils";

const InvoiceEngineDetailsFilter = ({ loadData, setMainFilters, filter }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [endDate, setEndDate] = useState("");

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else if (key === "createdAt") {
          payload["startDate"] = filters[key];
          if (endDate) {
            payload["endDate"] = endDate;
          }
        } else {
          payload[key] = filters[key];
        }
      }
      if (setMainFilters) {
        setMainFilters(payload);
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
      });
    } else {
      if (setMainFilters) {
        setMainFilters({});
      }
      loadData({ sortBy: "-createdAt", limit: PAGE_LIMIT, page: 1 });
    }
  };

  const filterTypes = [
    { label: "Filter by Plant", value: "organizationName" },
    { label: "Filter by Invoice Number", value: "invoiceNumber" },
    { label: "Filter by Invoice Date", value: "invoiceDate" },
    { label: "Filter by List/Part Number", value: "listNo" },
    { label: "Filter by Engine Number", value: "engineSerialNumber" },
    { label: "Filter by Created Date", value: "createdAt" },
  ];

  const renderFilterInput = () => {
    switch (filterType) {
      case "organizationName":
        return (
          <SiTextField
            placeholder="Plant"
            name="organizationName"
            onChange={handleFilterValueChange}
          />
        );
      case "invoiceNumber":
        return (
          <SiTextField
            placeholder="Invoice Number"
            name="invoiceNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "invoiceDate":
        return (
          <SiDatePicker
            onChange={(newValue) => {
              setFilterValue(newValue ? newValue.format("YYYY-MM-DD") : "");
            }}
          />
        );
      case "listNo":
        return (
          <SiTextField
            placeholder="List/Part Number"
            name="listNo"
            onChange={handleFilterValueChange}
          />
        );
      case "engineSerialNumber":
        return (
          <SiTextField
            placeholder="Engine Number"
            name="engineSerialNumber"
            onChange={handleFilterValueChange}
          />
        );
      case "createdAt":
        return (
          <Box sx={{ display: "flex", gap: "20px" }}>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>Start Date</p>
              <SiTextField
                placeholder="Start Date"
                name="startDate"
                type="date"
                onChange={handleFilterValueChange}
                sx={{ mt: 1 }}
              />
            </div>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>End Date</p>
              <SiTextField
                placeholder="End Date"
                name="endDate"
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ mt: 1 }}
              />
            </div>
          </Box>
        );
      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default InvoiceEngineDetailsFilter;
